function formatTimeToDate(time) {
  let date = new Date(time)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  month = month > 9 ? month : '0' + month
  let detailDate = date.getDate()
  detailDate = detailDate > 9 ? detailDate : '0' + detailDate
  return `${year}-${month}-${detailDate}`
}

function formaTimeToSecond(time) {
  let date = new Date(time)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  month = month > 9 ? month : '0' + month
  let detailDate = date.getDate()
  detailDate = detailDate > 9 ? detailDate : '0' + detailDate
  let hour = date.getHours()
  hour = hour > 9 ? hour : '0' + hour
  let minute = date.getMinutes()
  minute = minute > 9 ? minute : '0' + minute
  let second = date.getSeconds()
  second = second > 9 ? second : '0' + second
  return `${year}-${month}-${detailDate}  ${hour}:${minute}:${second}`
}

function orderStatusToDesc(status) {
  const statusToValueMap = {
    0: '待付款',
    1: '待审核',
    3: '已拒绝',
    4: '待审核',
    5: '待审核',
    7: '待发货',
    8: '待收货',
    9: '已完成',
    10: '已取消',
    11: '待确认收款'
  };
  return statusToValueMap[status];
}

function payMethodStatusToDesc(status) {
  const statusToValueMap = {
    0: '无',
    1: '线下付款',
    2: '支付宝',
    4: '农行支付',
    5: '微信支付',
    6: '线下支付宝转账',
    7: '线下微信转账',
    8: '线下其它转账',
  };
  return statusToValueMap[status];
}

function dbOrderStatusToValue(status) {
  const statusToValueMap = {
    0: '待付款',
    1: '待订单审核',
    2: '订单审核通过',
    3: '已拒绝',
    4: '待财务审核',
    5: '待出库审核',
    6: '待出库确认',
    7: '待发货',
    8: '待收货',
    9: '已完成',
    10: '已取消',
    11: '待确认收款'
  };
  return statusToValueMap[status];
}

function handleGetRequestParams(params) {
  let url = ''
  for (let key in params) {
    let value = (params[key] !== undefined && params[key] !== null) ? params[key] : '';
    url += `&${key}=${encodeURIComponent(value)}`
  }
  return url.substring(1)
}

function isImage(fileType) {
  return (
    fileType === 'image/jpeg' ||
    fileType === 'image/jpg' ||
    fileType === 'image/png'
  );
}

function isImgSizeLt2M(imgSize) {
  return imgSize / 1024 / 1024 < 2;
}

//获取整数规范
function getInteger(num) {
  let integer = num.toString().match(/^[1-9]\d*/)
    ? num.toString().match(/^[1-9]\d*/)[0]
    : num === "0"
      ? "0"
      : "";
  return integer;
}

export {
  formatTimeToDate,
  formaTimeToSecond,
  orderStatusToDesc,
  payMethodStatusToDesc,
  dbOrderStatusToValue,
  handleGetRequestParams,
  isImage,
  isImgSizeLt2M,
  getInteger
}
